// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__6jflc","containerItemsCenter":"Skeleton_containerItemsCenter__m-mg6"};